import { Message } from "../../../../model/chats/GroupConversationMessageModel";
import ApiService from "../../../../service/api/ApiService";
import ShowToast from "../../../../widget/common/ui/Toast";
import ApiUrls from "../../../../service/api/ApiUrls";
import CacheStorage from "../../../../service/storage/CacheStorage";
import StorageKeys from "../../../../const/StorageKeys";

const DepartmentChatsProvider = new (class DepartmentChatsProvider {
  groupByDate = (messages: Message[]) => {
    return messages.reduce<Record<string, Message[]>>((acc, msg) => {
      const date = msg?.create_date!.toString().split(" ")[0];
      if (!acc[date]) acc[date] = [];
      //acc[date].push(msg);
      acc[date] = [msg, ...acc[date]];
      return acc;
    }, {});
  };

  cancelARF = async (groupId: string, convId: string): Promise<boolean> => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);

    const url: string = `${ApiUrls.baseUrl}arf/cancel_appointment_reservation_details`;
    const body: any = {
      account_id: accountId,
      group_id: groupId,
      conv_id: convId,
    };

    console.log(body);
    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };
})();

export default DepartmentChatsProvider;
